import { Component, inject } from '@angular/core';
import { GeneralEventsService } from '../src/services/general-events.service';
import {
  AVAILABLE_LANGS,
  DEFAULT_LANG,
  Language,
  ShellV2Module,
  UserV2Service,
} from '@schenck/rotec-components';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'am-app',
  templateUrl: './app.component.html',
  imports: [ShellV2Module],
})
export class AppComponent {
  private readonly generalEventsService = inject(GeneralEventsService);
  private readonly translate = inject(TranslateService);
  private readonly userService = inject(UserV2Service);

  constructor() {
    this.userService.currentUser$.pipe(filter((user) => !!user)).subscribe((user) => {
      this.setLanguage(user.language);
    });
  }

  public sideBarCollapse(collapsed: boolean) {
    this.generalEventsService.toggleSidebar(collapsed);
  }

  private setLanguage(lang: Language) {
    const useLang = AVAILABLE_LANGS.includes(lang) ? lang : DEFAULT_LANG;

    this.translate.addLangs(AVAILABLE_LANGS);
    this.translate.use(useLang);
    !lang && localStorage.setItem('language', useLang);
  }
}
